var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcnStrokeCloseHaseGreen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "600px",
    height: "600px",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icn_stroke_close_hase_green") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M143.756068,122.542864 L261.905534,4.39339828 C267.763398,-1.46446609 277.260873,-1.46446609 283.118737,4.39339828 C288.976602,10.2512627 288.976602,19.7487373 283.118737,25.6066017 L164.969271,143.756068 L283.118737,261.905534 C288.976602,267.763398 288.976602,277.260873 283.118737,283.118737 C277.260873,288.976602 267.763398,288.976602 261.905534,283.118737 L143.756068,164.969271 L25.6066017,283.118737 C19.7487373,288.976602 10.2512627,288.976602 4.39339828,283.118737 C-1.46446609,277.260873 -1.46446609,267.763398 4.39339828,261.905534 L122.542864,143.756068 L4.39339828,25.6066017 C-1.46446609,19.7487373 -1.46446609,10.2512627 4.39339828,4.39339828 C10.2512627,-1.46446609 19.7487373,-1.46446609 25.6066017,4.39339828 L143.756068,122.542864 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn_stroke_close_hase_green",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(156.000000, 156.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#34A344",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnStrokeCloseHaseGreen);
export default __webpack_public_path__ + "static/media/icn_stroke_close_hase_green.293708822c4c2443350fe6e73b1871a1.svg";
export { ForwardRef as ReactComponent };